import React from "react";
import "./Requirements.css";
import { Trans, useTranslation } from "react-i18next";
const CanparRequirements = () => {
  const { t } = useTranslation("settings");
  return (
    <div className="cuscarrier__reqrmnts_box">
      <Trans
        t={t}
        i18nKey="carriers.custom.requirements.canpar"
        components={{
          mail: (
            <a href={`mailto:servicedesk@canpar.com`} className="email_space">
              servicedesk@canpar.com
            </a>
          ),
        }}
      />
    </div>
  );
};

export default CanparRequirements;
